import React from "react"
import { Flex } from "antd"
import GridTypeA from "components/grids/GridTypeA/GridTypeA"

const approvalDetailsColSet = new Set([
  "created_at",
  "created_by_fullname",
  "form_types",
  // "esign_failed",
  "outcome",
  "comments",
])

const formViewMap = {
  eudract: "eudra",
  "ema rwd": "eupas",
}

export default function VersionDetails({
  showVersion,
  approvalHistoryColDefs,
  approvals = [],
  formVersion,
  formTypes,
  formView,
  showApprovalGrid,
  setShowApprovalGrid,
  selectedForms,
}) {
  const [filteredApprovalData, setFilteredApprovalData] = React.useState([])

  React.useEffect(() => {
    const normalize = (str) => str?.toLowerCase().replace(/_/g, " ").trim()
    const filterApprovalsByForm = () => {
      if (formView && formVersion && approvals) {
        const filteredData = approvals.filter((item) => {
          let isValid = false

          if (item.form_version === formVersion?.id) {
            if (formView && selectedForms()) {
              item.form_types.forEach((type) => {
                let typeFormView = type.form_view?.toLowerCase()
                let formattedTypeFormView = formViewMap?.[typeFormView] || typeFormView
                if (formattedTypeFormView === formView) {
                  selectedForms().forEach((selectedFormType) => {
                    if (normalize(type.form_section) === normalize(selectedFormType.form_section)) {
                      isValid = true
                    }
                  })
                }
              })
            } else if (formView) {
              item.form_types.forEach((type) => {
                let typeFormView = type.form_view?.toLowerCase()
                let formattedTypeFormView = formViewMap?.[typeFormView] || typeFormView

                if (formattedTypeFormView === formView) {
                  isValid = true
                }
              })
            }
          }

          return isValid
        })

        setFilteredApprovalData(filteredData)
      }
    }
    filterApprovalsByForm()
  }, [formView?.id, formTypes, formVersion])

  const filteredCols = React.useMemo(() => {
    return approvalHistoryColDefs.filter((col) => approvalDetailsColSet.has(col.field))
  }, [])

  if (!showVersion || filteredApprovalData.length === 0) {
    return
  }

  return (
    <div className="approval-details-grid-container">
      <Flex
        className="approval-details-header-container"
        align="center"
        gap={6}
        onClick={() => setShowApprovalGrid(!showApprovalGrid)}
      >
        <i className={`fa-light fa-chevron-${showApprovalGrid ? "up" : "down"}`} />
        {<span>{showApprovalGrid ? "Hide" : "Show"} version details</span>}
      </Flex>
      {showApprovalGrid && formVersion && filteredApprovalData.length > 0 && (
        <div>
          <GridTypeA
            columnDefs={filteredCols}
            rowData={filteredApprovalData}
            domLayout="autoHeight"
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={[10, 20, 50]}
          />
        </div>
      )}
    </div>
  )
}
